import { Layout } from '@/utils/routerHelper'
/*不需要菜单的静态资源*/
export const ecoEnterpriseStaticRouterMapFront: AppRouteRecordRaw[] = [
  {
    path: '/ecoenterprise/emission',
    component: Layout,
    name: 'emission',
    meta: {
      hidden: true,
      canTo: true
    },
    redirect: '/ecoenterprise/emission/emissionCoefficient',
    children: [
      {
        path: 'emissionDetail',
        component: () => import('@enp/views/emissionCoefficient/emissionDetail.vue'),
        name: 'emissionDetail',
        meta: {
          hidden: true,
          canTo: true,
          noTagsView: true,
          activeMenu: 'emissionCoefficient'
        }
      }
    ]
  },
  // 碳排放数据填报：厂务
  {
    path: '/ecoenterprise/emissionDataFilling',
    component: Layout,
    name: 'emissionDataFilling',
    meta: {
      hidden: true,
      canTo: true
    },
    redirect: '/ecoenterprise/emissionDataFilling/fillList',
    children: [
      {
        path: 'fillData',
        component: () => import('@enp/views/emissionFillingCalc/fillCalcData.vue'),
        name: 'fillData',
        meta: {
          hidden: true,
          canTo: true,
          noTagsView: true,
          activeMenu: 'emissionDataFilling'
        }
      }
    ]
  },
  // 碳排量计算：reviewer
  {
    path: '/ecoenterprise/emissionCalc',
    component: Layout,
    name: 'emissionCalc',
    meta: {
      hidden: true,
      canTo: true
    },
    redirect: '/ecoenterprise/emissionCalc/calcList',
    children: [
      {
        path: 'calcData',
        component: () => import('@enp/views/emissionFillingCalc/fillCalcData.vue'),
        name: 'calcData',
        meta: {
          hidden: true,
          canTo: true,
          noTagsView: true,
          activeMenu: 'emissionCalc'
        }
      }
    ]
  },
  {
    path: '/ecoenterprise/review',
    component: Layout,
    name: 'review',
    meta: {},
    redirect: '/ecoenterprise/review/dataReview',
    children: [
      {
        path: 'auditActivityData',
        component: () => import('@enp/views/dataReview/auditActivityData.vue'),
        name: 'auditActivityData',
        meta: {
          hidden: true,
          canTo: true,
          noTagsView: true,
          activeMenu: 'review'
        }
      }
    ]
  }
]
